import React, { useState, useContext, useEffect } from "react";

import {
  SidePanel,
  Button,
  FormFooter,
} from "xsolla-uikit";

import styled, { css } from 'styled-components';

export default function PAsidePanel({
  isOpen = false,
  header,
  handleClose,
  children,
  z = true,
}) {

  const [open, setOpen] = useState(isOpen !== false ? true : false);
  const [open2, setOpen2] = useState(false);

  useEffect(() => {
    let tim;
    if (open !== false) {
      tim = setTimeout(()=>{
        setOpen2(true)
      }, 10)
    } else {
      setOpen2(false)
    }
    return () => {
      if (typeof tim !== 'undefined') clearTimeout(tim);
    };
  }, [open])

  useEffect(() => {
    if (isOpen !== open) setOpen(isOpen)
  }, [isOpen])


  const closeModal = ()=> {
    let tim;
    setOpen2(false)
    setOpen(false)
    handleClose()
    // tim = setTimeout(()=>{
    // }, 10)
  }

  return (
    <div style={{
      position: open !== false ? 'fixed' : 'none',
      zIndex: 10000,
    }}>

      {!!open2 && <div style={{
          position: 'fixed',
          display: 'flex',
          right: 24,
          top: 18,
          zIndex: 21,
        }}>
        <div
          className="xsui-side-panel__icon xsui-side-panel__icon--close"
          onClick={()=>{
            setOpen(false);
            handleClose();
          }}
        >
          <i className="xsui-icon xsui-icon-close" style={{fontSize: 32, color: 'rgb(189, 201, 210)'}} />
        </div>
      </div>}

      {/* <div
        className={`xsui-backdrop${open2 ? " xsui-backdrop--show" : ""}`}
        onClick={()=>{
          setOpen(false);
          handleClose();
        }}
        // onClick={handleClose}
        style={{pointerEvents: !z ? 'none' : 'auto'}}
      ></div> */}

      <aside
        className={`xsui-side-panel${open2 ? " xsui-side-panel--open" : ""}`}
        style={{paddingBottom: 94}}
      >

        <div className="xsui-side-panel__container" style={{height:'auto'}}>
          <div className="xsui-side-panel__content" style={{paddingTop:0}}>
            {typeof children === 'function' && children()}
            {typeof children !== 'function' && children}
          </div>
        </div>


      </aside>

      {open && <CssFormFooter
        open={open2}
        // className={`xsui-side-panel${open2 ? " xsui-side-panel--open" : ""}`}
      >
        <div style={{backgroundColor: 'white',}}>
          <FormFooter indentation="lg">
            <Button appearance="outline" onClick={() => closeModal()}>
              Discard
            </Button>
            <Button type="submit" onClick={() => closeModal()}>
              Save changes
            </Button>
          </FormFooter>
        </div>
      </CssFormFooter>}



    </div>
  )
}

const CssFormFooter = styled.div`
  padding: 0 24px 24px 24px;
  position: fixed;
  width: 560px;
  bottom: 0;
  z-index: 1000;
  right:-600px;
  transition: all .2s ease-in-out;
  ${({open})=> !!open && css`
      right:0;
    `
  };
`